export const layers = {
  blanket: "var(--z-index-blanket)",
  modal: "var(--z-index-modal)",
} as const;
/**
 * z-index: ${layers.blanket};
 */
